import React from 'react'

const Eventvendorcoustomercare = () => {
    return (
        <div>

        </div>
    )
}

export default Eventvendorcoustomercare
